import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getOtps = createAsyncThunk(
  "otps/getOtps",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query, user } = args;
      const filter = filterRequest(args.filter);

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("size", size);
      if (query) params.append("search", query);
      if (user) params.append("user", user);

      const { data } = await axiosInstance.get(
        `/requests/otp?${params.toString()}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateOtp = createAsyncThunk(
  "otps/updateOtp",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/requests/otp/${args._id}`,
        {
          status: args.status,
          reason: args.reason,
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getOtpById = createAsyncThunk(
  "otps/getOtpById",
  async (id, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/requests/otp/${id}`);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const otpsSlice = createSlice({
  name: "otps",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOtps.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getOtps.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // Handle both possible API response structures
      state.data = payload.data?.data || payload.data || [];
      state.pages = payload.data?.pages || payload.pages || 0;
      state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
      state.error = null;
    });
    builder.addCase(getOtps.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });

    builder.addCase(updateOtp.pending, (state) => {
      state.isLoading = true;
      // state.error = null;
    });
    builder.addCase(updateOtp.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // const indexAt = state.data.findIndex((el) => el._id === payload.data._id);
      // state.data[indexAt] = payload.data;
      // state.error = null;
    });
    builder.addCase(updateOtp.rejected, (state, { payload }) => {
      state.isLoading = false;
      // state.error = payload?.message;
    });

    builder.addCase(getOtpById.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getOtpById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(getOtpById.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });
  },
});

export default otpsSlice.reducer;
